import React, { useContext } from 'react';
import { Link } from "react-router-dom";
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import translate from '../i18n/translate';
import { SessionContext } from '../services/SessionProvider';
//import { KeycloackContext } from '../services/keycloakProvider';

const Questionnaire = () => {
    const { setDebutQuestionnaire } = useContext(SessionContext);
    //const { isAdminRole } = useContext(KeycloackContext);

    const handleCommencer = () => {
        // ⚡ Exécute en arrière-plan sans bloquer la navigation
        Promise.resolve().then(() => setDebutQuestionnaire());
    };

    return (
        <main style={{ display: "grid", justifyItems: "center", marginTop: "100px" }}>
            <Typography component="h1" variant="h2" align="center" color="text.primary" gutterBottom marginTop="8rem">
                {translate("questionnaire.questionnaire_ami")}
            </Typography>
            <Typography component="p" variant="p" align="center" fontSize="1.25rem" gutterBottom>
                {translate("questionnaire.app_prealable")}
            </Typography>
            <Link style={{ textDecoration: 'none' }} to="/questionnaire/0">
                <Button
                    onClick={handleCommencer}
                    variant="contained"
                    sx={{
                        backgroundColor: "#307B5B",
                        "&:hover": { backgroundColor: "#8EBF55", color: "black", fontWeight: "bold" },
                    }}
                    style={{ width: "25rem", height: "4rem", marginTop: "3rem" }}
                >
                    {translate("questionnaire.commencer")}
                </Button>
            </Link>
            {/* { isAdminRole && <Link style={{textDecoration: 'none'}} to="/historique">
                <Button onClick={handlegetHistoriqueAdmin} variant="contained" color="success" style={{width: "300px", height: "50px", marginTop: "50px"}}> Get Historique Admin </Button>
            </Link>} */}
        </main>
    );
};

export default Questionnaire;
